function tabs(fade) {

    const elTabs = document.getElementsByClassName('product-tab')
    const elTabContainers = document.getElementsByClassName('product-tabs-container')

    if (elTabs) {
        Array.from(elTabs).forEach(function(elTab) {
            elTab.addEventListener('click', function () {

                Array.from(elTabs).forEach(function(el) {
                    el.classList.remove('active')
                })

                this.classList.add('active')
                const elSelected = this

                Array.from(elTabContainers).forEach(function(elTabContainer) {
                    if (elTabContainer.dataset.id === elSelected.dataset.id) {
                        elTabContainer.classList.add('active')
                        fade.fadeIn(elTabContainer,'flex')
                    } else {
                        elTabContainer.classList.remove('active')
                        fade.fadeOut(elTabContainer)
                    }
                })

            })
        })
    }

}

module.exports = {tabs}
